import { useEffect } from 'react';

export function useFocusTrap(
	ref: React.RefObject<HTMLElement>,
	isOpen: boolean,
) {
	useEffect(() => {
		if (!isOpen || !ref.current) return;

		const dialogElement = ref.current;

		// We can add more stuff here if we use this hook somewhere else or we add more stuff to our search box
		const focusableSelectors = [
			'a[href]',
			'button:not([disabled])',
			'input[type="text"]:not([disabled])',
			'[tabindex]:not([tabindex="-1"])',
		];

		const focusableEls = dialogElement.querySelectorAll<HTMLElement>(
			focusableSelectors.join(','),
		);
		const firstEl = focusableEls[0];
		const lastEl = focusableEls[focusableEls.length - 1];

		// Focus the first element
		firstEl?.focus();

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key !== 'Tab') return;

			if (e.shiftKey) {
				// If Shift+Tab
				if (document.activeElement === firstEl) {
					e.preventDefault();
					lastEl.focus();
				}
			} else {
				// Tab
				if (document.activeElement === lastEl) {
					e.preventDefault();
					firstEl.focus();
				}
			}
		};

		dialogElement.addEventListener('keydown', handleKeyDown);

		return () => {
			dialogElement.removeEventListener('keydown', handleKeyDown);
		};
	}, [ref, isOpen]);
}
